// extracted by mini-css-extract-plugin
export default {"checkbox":"checkbox---rEGVP","checkboxContainer":"checkboxContainer---oL_Zy"};